import React from 'react';

const linkClick = (callback) => {
	return (e) => {
		e.stopPropagation();
		e.preventDefault();
		callback(e);
	};
};

export default function Paginator({ pagination, ...props }) {
	const {
		backPage,
		canGoBackPage,
		canGoNextPage,
		isLoading,
		nextPage,
		page,
		pageSize,
		setPageSize,
		goToPage,
	} = pagination;

	return (
		<div className={`d-flex flex-column align-items-${props.align || 'start'}`}>
			<nav>
				<ul className="pagination pagination-sm mb-2">
					<li className={`page-item ${isLoading || page === 1 ? 'disabled' : ''}`}>
						<a className='page-link mr-1' href={isLoading || page === 1 ? undefined : ''} onClick={linkClick(() => goToPage(1))}>{'|<'}</a>
					</li>
					<li className={`page-item ${!canGoBackPage || isLoading ? 'disabled' : ''}`}>
						<a className='page-link mr-1' href={!canGoBackPage || isLoading ? undefined : ''} onClick={linkClick(() => backPage())}>{'<'}</a>
					</li>
					<li className="page-item">
						<div className="page-link">{page}</div>
					</li>
					<li className={`page-item ${!canGoNextPage || isLoading ? 'disabled' : ''}`}>
						<a className='page-link ml-1' href={!canGoNextPage || isLoading ? undefined : ''} onClick={linkClick(() => nextPage())}>{'>'}</a>
					</li>
				</ul>
			</nav>

			<nav>
				<ul className="pagination pagination-sm mb-0">
					<li className={`page-item ${isLoading || pageSize === 10 ? 'disabled' : ''}`}>
						<a className="page-link py-0 px-1" href={isLoading || pageSize === 10 ? undefined : ''} onClick={linkClick(() => setPageSize(10))}> 10 </a>
					</li>
					<li className={`page-item ${isLoading || pageSize === 25 ? 'disabled' : ''}`}>
						<a className="page-link py-0 px-1" href={isLoading || pageSize === 25 ? undefined : ''} onClick={linkClick(() => setPageSize(25))}> 25 </a>
					</li>
					<li className={`page-item ${isLoading || pageSize === 50 ? 'disabled' : ''}`}>
						<a className="page-link py-0 px-1" href={isLoading || pageSize === 50 ? undefined : ''} onClick={linkClick(() => setPageSize(50))}> 50 </a>
					</li>
					<li className={`page-item ${isLoading || pageSize === 100 ? 'disabled' : ''}`}>
						<a className="page-link py-0 px-1" href={isLoading || pageSize === 100 ? undefined : ''} onClick={linkClick(() => setPageSize(100))}> 100 </a>
					</li>
					<li className={`page-item ${isLoading || pageSize === 150 ? 'disabled' : ''}`}>
						<a className="page-link py-0 px-1" href={isLoading || pageSize === 150 ? undefined : ''} onClick={linkClick(() => setPageSize(150))}> 150 </a>
					</li>
					<li className={`page-item ${isLoading || pageSize === 200 ? 'disabled' : ''}`}>
						<a className="page-link py-0 px-1" href={isLoading || pageSize === 200 ? undefined : ''} onClick={linkClick(() => setPageSize(200))}> 200</a>
					</li>
				</ul>
			</nav>
		</div>

	);
}
